<script setup>
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

import { getUserByUid } from '@/firebase_files/user_functions';
import { uid } from '@/firebase_files/login';


import EditPhysician from './EditPhysician.vue';
import EditSecretary from './EditSecretary.vue';

const route = useRoute();
const role = route.params.role;
const newAct = route.params.newAct;
// four states, new/edit, dr/agent from query params
const state = reactive({
  newAct: null, 
  role: null,
  oldUser: null,
  titleText:'Create',
})

function setRole(role) {
  state.role = role;
  state.newAct = true;
}

init();
async function init() {
  // convert to boolean
  if (newAct == 'true') { // query params are strings
    state.newAct = true;
    state.role = role; // new account, get role from query params
  } else {
    state.newAct = false;
    state.oldUser = await getUserByUid(uid);
    state.role = state.oldUser.role;
    state.titleText = 'Edit';
  }

}


</script>
<template>
  <div class="page-title">
    <div class="title">
      <h2>{{ state.titleText}} Account Information</h2>
    </div>
  </div>
  <div v-if='state.role' class="content-box container">
    <EditPhysician v-if="state.role == 'physician'" :user="state.oldUser" />
    <EditSecretary v-else-if="state.role == 'secretary'" :user="state.oldUser" />
  </div>
  <div v-else>
    <h1>Welcome to Verus, please select the account type you'd like to create:</h1>
    <button @click="setRole('physician')">Physician</button>
    <button @click="setRole('secretary')">Secretary</button>
  </div>

</template>

<style scoped lang="scss">
.entry {
  display: flex;
  flex: 1 0 100%;
  margin: 1rem 0;
}

.page-title {
  background-color: #fff;
  padding: 1.25rem;
  border-radius: 1rem;
  margin: 1rem 0;
  border: 1px solid #ccc;
  border-top: 5px solid #673ab7;

  .title {
    font-size: 25px;
    text-align: center;

    h2 {
      margin: 0;
      padding: 0%;
    }
  }
}
</style>